import { useSelector, useDispatch } from 'react-redux';
import { favoritesShow } from '../../store/favoritesSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as hide } from '@fortawesome/free-regular-svg-icons';
import { faHeart as show } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import './FavSwitcher.css';

const FavSwitcher = () => {
    const event = useSelector(state => state.event);
    const isVisible = useSelector(state => state.favorites.isVisible);
    const dispatch = useDispatch();
    const [ icon, setIcon ] = useState(isVisible ? show : hide);

    useEffect(() => {
        setIcon(isVisible ? show : hide);
    }, [isVisible]);

    return (
        <React.Fragment>
        {event &&
        <FontAwesomeIcon
                icon={icon}
                size='2x'
                className='FavSwitcher'
                onClick={() => dispatch(favoritesShow(!isVisible))}
        />}
        </React.Fragment>
	);
};

export default FavSwitcher;
